export const SHOW_PREVIEW = 'SHOW_PREVIEW'
export const HIDE_PREVIEW = 'HIDE_PREVIEW'
export const SET_CARTED = 'SET_CARTED'
export const SET_EDIT_ITEM = 'SET_EDIT_ITEM'
export const SET_INPUT = 'SET_INPUT'
export const SET_LOCAL_CART_ITEM = 'SET_LOCAL_CART_ITEM'
export const UNSET_LOCAL_CART_ITEM = 'UNSET_LOCAL_CART_ITEM'
export const CLEAR_LOCAL_CART_ITEMS = 'CLEAR_LOCAL_CART_ITEMS'
